import { HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { GeoJsonObject } from 'geojson';
import { GeoJSON, geoJSON } from 'leaflet';
import { MAP_RENDERER } from '../../../map-config';
import {
  landAgreementColors,
  landAgreementStyles,
} from '../../../span-progress-view/map-view-constants';
import { MapApiService } from '../../api/map-api.service';
import { AbstractLayerService } from '../abstract-layer.service';

@Injectable({ providedIn: 'root' })
export class LandAgreementService extends AbstractLayerService<GeoJSON<GeoJSON.GeoJsonProperties> | null> {
  constructor(private readonly apiService: MapApiService) {
    super(null);
  }
  loadData = this.loadLandAgreementData;

  loadLandAgreementData(ifs: string) {
    this.setLoading();
    this.apiService.getLandAgreementGeoJson(ifs).subscribe({
      next: (geoJsonResponse) => {
        this.initLandAgreementLayer(geoJsonResponse);
        this.setLoaded();
      },
      error: (err: HttpErrorResponse) => this.handleError(err),
    });
  }

  initLandAgreementLayer(geoJson: GeoJsonObject) {
    this.layerData = geoJSON(geoJson, {
      style: (feature: GeoJSON.Feature) => {
        const status = feature?.properties?.status;
        return {
          ...landAgreementStyles.default,
          ...this.setLandagreementStyles(status),
          renderer: MAP_RENDERER,
        };
      },
    }).on('click', (e) => this.onClick(e));
  }

  setLandagreementStyles(status: string) {
    switch (status) {
      case 'Avtal klart':
        return {
          color: landAgreementColors.DONE,
          fillColor: landAgreementColors.DONE,
        };
      case 'Avtal behövs ej':
        return {
          color: landAgreementColors.NOT_NEEDED,
          fill: false,
          dashArray: [8],
          opacity: 0.7,
        };
      default:
        return {
          color: landAgreementColors.NOT_COMPLETED,
          fillColor: landAgreementColors.NOT_COMPLETED,
        };
    }
  }

  clearData() {
    super.clearData();
  }
}
